(() => {
  if (window.KASSpendSave) { window.KASSpendSave.refresh(); return; }
  let observer;
  let scheduled = false;
  let activeHost;
  let offer;
  let mount;
  const cleanLegacy = () => {
    if (!mount) return;
    mount.querySelectorAll('.kas-product__spend,#spendsave').forEach(element => { element.hidden = true; });
    mount.querySelectorAll('.product-text').forEach(element => {
      const text = element.textContent.replace(/\s+/g,' ').trim();
      if (/^\*?\s*Spend\s*&\s*Save Offer applies to all products except Counters & Slatwall Stands\.?$/i.test(text)) element.hidden = true;
    });
  };
  const firstDisplayed = selector => Array.from(mount.querySelectorAll(selector)).find(element => !element.hidden && element.style.display !== 'none');
  const productAnchor = () => firstDisplayed('.product-main .nm-wholesale-table-container, .kas-product__purchase .nm-wholesale-table-container')
    || mount.querySelector('.kas-product__purchase .kas-product__buy-row')
    || mount.querySelector('.product-main .product-form--atc')
    || mount.querySelector('[data-product-atc], [data-add-button]')
    || mount.querySelector('form[action*="/cart/add"]')
    || mount.querySelector('h1');
  const collectionAnchor = () => mount.querySelector('.kas-collection__header')
    || mount.querySelector('.productgrid--masthead')
    || mount.querySelector('h1')?.closest('header')
    || mount.querySelector('h1');
  const place = () => {
    scheduled = false;
    cleanLegacy();
    if (!offer || !mount || activeHost?.dataset.eligible !== 'true') return;
    const anchor = activeHost.dataset.page === 'product' ? productAnchor() : collectionAnchor();
    if (!anchor || anchor === offer || offer.contains(anchor)) return;
    if (anchor.nextElementSibling !== offer) anchor.insertAdjacentElement('afterend',offer);
    offer.hidden = false;
  };
  const queuePlace = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(place);
  };
  const refresh = () => {
    const host = document.querySelector('[data-kas-spend-save-host]');
    mount = document.querySelector('#site-main');
    if (!mount || !host) { observer?.disconnect(); offer?.remove(); offer = null; activeHost = null; return; }
    if (host !== activeHost) {
      offer?.remove();
      activeHost = host;
      offer = host.querySelector('[data-kas-spend-save]');
    }
    observer?.disconnect();
    place();
    observer = new MutationObserver(queuePlace);
    observer.observe(mount,{childList:true,subtree:true});
  };
  window.KASSpendSave = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',refresh,{once:true});
  else refresh();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',refresh);
})();
